"use strict";

(function (window) {
  window.siteHeader = null;
  window.siteFooter = null;
  window.searchModal = null;
  window.siteQuickCart = null;
  window.sitePageChangeCurtain = null;
  window.siteHelperModal = null;
  window.siteNewsletterModal = null; // window.privacyCookiePolicy = null;
  // let window.pageVisitRequest;

  var HOME_PAGE = "ae--homepage-page";
  var COLLECTION_PAGE = "ae--collection-page";
  var PRODUCT_PAGE = "ae--product-page";
  var CART_PAGE = "ae--brands-page";
  var BRANDS_PAGE = "ae--cart-page";
  var STORES_PAGE = "ae--stores-page";
  var ARTICLE_PAGE = "ae--article-page";
  var ABOUT_PAGE = "ae--about-page";
  var REGISTER_PAGE = "ae--register-page";
  var LOGIN_PAGE = "ae--login-page";
  var MAGAZINE_PAGE = "ae--magazine-page";
  var ACCOUNT_PAGE = "ae--account-page";
  var ACTIVATE_ACCOUNT_PAGE = "ae--activate-account-page";
  var SUPPORT_AND_INFO = "ae--support-and-info-page";
  var NOTFOUND_PAGE = "ae--404-page";
  var RESET_PASSWORD_PAGE = "ae--reset-password-page";
  var CUSTOMER_ADDRESSES_PAGE = "ae--customer-addresses-page";
  var ORDER_PAGE = "ae--order-page";
  var SEARCH_PAGE = "ae--search-page";
  var WORK_WITH_US_PAGE = "ae--work-with-us-page";
  var TYPOGRAPHY_PAGE = "ae--typography-page";
  window.currentSection = null;
  $(document).ready(onDocumentReady);

  function onDocumentReady() {
    console.log("%c ********** ON_DOCUMENT_READY **********", "background: #000000; color: #FFFFFF; padding-right: 30px;", "testing new DHQ");
    sitePageChangeCurtain = new window.PageTransitionCurtain();
    sitePageChangeCurtain.$domElement.on(AbstractElement.EL_SHOW_COMPLETE, function (event, el) {
      window.TweenMax.set(".site-wrapper", {
        autoAlpha: 0
      });
      window.Turbolinks.visit(window.pageVisitRequest.url);
    });
    sitePageChangeCurtain.$domElement.on(AbstractElement.EL_HIDE_START, function (event, el) {
      window.TweenMax.set(".site-wrapper", {
        autoAlpha: 1,
        clearProps: "all"
      });
    });
    sitePageChangeCurtain.$domElement.one(AbstractElement.EL_HIDE_COMPLETE, function (event, el) {
      $("html.first-load").removeClass("first-load");
    });
    sitePageChangeCurtain.$domElement.on(AbstractElement.EL_HIDE_COMPLETE, function (event, el) {
      $("html").removeClass("turbolinks-page-changing");
    });
    sitePageChangeCurtain.init(); // privacyCookiePolicy = new window.PrivacyCookiePolicy(destroyPrivacyPolicy);
    // privacyCookiePolicy.init();

    siteQuickCart = new window.QuickCart();
    siteQuickCart.init();
    searchModal = new window.SearchModal();
    searchModal.init();
    siteHelperModal = new window.HelperModal();
    siteHelperModal.init();
    siteNewsletterModal = new window.NewsletterModal();
    siteNewsletterModal.init();
    siteHeader = new window.SiteHeader("site-header-permanent", {
      $domElement: $("#site-header-permanent"),
      showSearchModalCallback: showSearchModal,
      showQuickCartCallback: siteQuickCart.show.bind(siteQuickCart),
      changeLanguageCallback: changeLanguage
    });
    window.siteHeaderRef = siteHeader;
    siteHeader.init();
    siteFooter = new window.SiteFooter();
    siteFooter.init();
    siteQuickCart.$domElement.on(QuickCart.QUANTITY_UPDATE, function (event, quantity) {
      siteHeader.cartQuantity = quantity;
    });
    /**
     *   Unlisten for turbolinks
     */

    $(document).on("turbolinks:load", turbolinksLoad);
    $(document).on("turbolinks:click", turbolinksClick);
    $(document).on("turbolinks:before-visit", turbolinksBeforeVisit);
    $(document).on("turbolinks:visit", turbolinksVisit);
    $(document).on("turbolinks:request-start", turbolinksRequestStart);
    $(document).on("turbolinks:request-end", turbolinksRequestEnd);
    $(document).on("turbolinks:before-cache", turbolinksBeforeCache);
    $(document).on("turbolinks:before-render", turbolinksBeforeRender);
    $(document).on("turbolinks:render", turbolinksRender);
    /*
     *   turbolinks:load isn't executed after the document ready
     */

    $(document).trigger("turbolinks:load");
    $(document).on(ProductsGrid.QUICK_VIEW_SCROLL_TOP, function (event, type) {
      if (!siteHeader.isHidden) {
        siteHeader.hide();
      }
    });

    if (Detectizr.os.name == "ios") {
      throttled_iOsResizeHandler();
      $(window).on("resize", _.throttle(throttled_iOsResizeHandler, 100, []));
    }

    if (Detectizr.os.name == "ios" && Detectizr.os.major >= 13) {
      (function () {
        var touchingCarousel = false,
            touchStartCoords;
        document.body.addEventListener("touchstart", function (e) {
          if (e.target.closest(".flickity-slider")) {
            touchingCarousel = true;
          } else {
            touchingCarousel = false;
            return;
          }

          touchStartCoords = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          };
        });
        document.body.addEventListener("touchmove", function (e) {
          if (!(touchingCarousel && e.cancelable)) {
            return;
          }

          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
          };
          if (Math.abs(moveVector.x) > 7) e.preventDefault();
        }, {
          passive: false
        });
      })();
    }
  } // function destroyPrivacyPolicy() {
  //   if (privacyCookiePolicy) {
  //     privacyCookiePolicy.dispose();
  //     privacyCookiePolicy = null;
  //   }
  // }


  function showSearchModal(event) {
    searchModal.show();
  }

  function turbolinksLoad(event) {
    console.log("%c Turbolinks: " + event.type, "background: #00b12a; color: #FFFFFF; padding-right: 30px;", $("body").attr("class"));

    if ($("body").hasClass("template-index")) {
      window.currentSection = new window.HomePage(HOME_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-collection")) {
      window.currentSection = new window.CollectionPage(COLLECTION_PAGE, {
        $domElement: $(".collection-page")
      });
    } else if ($("body").hasClass("template-product")) {
      window.currentSection = new window.ProductPage(PRODUCT_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-cart")) {
      window.currentSection = new window.CartPage(CART_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-stores")) {
      window.currentSection = new window.StoresPage(STORES_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-article")) {
      window.currentSection = new window.ArticlePage(ARTICLE_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-about")) {
      window.currentSection = new window.AboutPage(ABOUT_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-register")) {
      window.currentSection = new window.RegisterPage(REGISTER_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-login")) {
      window.currentSection = new window.LoginPage(LOGIN_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-blog")) {
      window.currentSection = new window.MagazinePage(MAGAZINE_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-customers-account")) {
      window.currentSection = new window.AccountPage(ACCOUNT_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-support-and-info")) {
      window.currentSection = new window.SupportAndInfo(SUPPORT_AND_INFO, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-404")) {
      window.currentSection = new window.NotFoundPage(NOTFOUND_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-reset_password")) {
      window.currentSection = new window.ResetPasswordPage(RESET_PASSWORD_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-customers-addresses")) {
      window.currentSection = new window.CustomerAddressesPage(CUSTOMER_ADDRESSES_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-order")) {
      window.currentSection = new window.OrderPage(ORDER_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-activate_account")) {
      window.currentSection = new window.ActivateAccountPage(ACTIVATE_ACCOUNT_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-typography")) {
      window.currentSection = new window.TypographyPage(TYPOGRAPHY_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-brands")) {
      window.currentSection = new window.BrandsPage(BRANDS_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-search")) {
      window.currentSection = new window.SearchPage(SEARCH_PAGE, {
        $domElement: $("#main-content")
      });
    } else if ($("body").hasClass("template-page-work-with-us")) {
      window.currentSection = new window.WorkWithUsPage(WORK_WITH_US_PAGE, {
        $domElement: $("#main-content")
      });
    } else {
      window.currentSection = null;
    }

    if (window.currentSection) {
      siteHeader.turbolinksLoad();
      searchModal.turbolinksLoad();
      window.currentSection.init();
      $(window).off(CartPage.CART_CHANGE_SUCCESS).on(CartPage.CART_CHANGE_SUCCESS, function (event, response) {
        console.log("%c-----------> CART SUCCESS: ", "color: green;", response);
        siteQuickCart.update(response);

        if (window.currentSection instanceof CartPage) {
          window.currentSection.update(response);
        }
      });
      $(window).off(CartPage.CART_CHANGE_ERROR).on(CartPage.CART_CHANGE_ERROR, function (event, response) {
        console.log("%c-----------> CART ERROR: ", "color: red;", response);
      });
      /*$(window).off(Globals.VARIANT_UPDATED).on(Globals.VARIANT_UPDATED, function(event, response) {
                console.log("%c----> VARIANT_UPDATED: ", "color: blue;", response);
            });
             $(window).off(Globals.ALL_VARIANTS_UPDATED).on(Globals.ALL_VARIANTS_UPDATED, function(event, response) {
                console.log("%c----> ALL_VARIANTS_UPDATED: ", "color: blue;", response);
            });*/
    }

    if (window.pageVisitRequest || $("html").hasClass("first-load")) {
      if (window.pageVisitRequest) window.pageVisitRequest = null;
      sitePageChangeCurtain.hide();
    } else {
      window.TweenMax.set(".site-wrapper", {
        autoAlpha: 1,
        clearProps: "all"
      });
      $("html").removeClass("turbolinks-page-changing");
    }
  }

  function turbolinksClick(event) {
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", $("body").attr("class"));
    window.pageVisitRequest = {
      url: event.originalEvent.data.url.replace(window.location.origin, ""),
      needsPreventDefault: true
    };
  }

  function turbolinksBeforeVisit(event) {
    // Restoration visits cannot be canceled and do not fire turbolinks:before-visit
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", window.pageVisitRequest, $("body").attr("class"));
    Globals.PREVIOUS_PAGE = location.pathname;
    $("html").addClass("turbolinks-page-changing");

    if (window.pageVisitRequest && window.pageVisitRequest.needsPreventDefault) {
      event.preventDefault();
      window.pageVisitRequest.needsPreventDefault = false;
      sitePageChangeCurtain.show();
    }
  }

  function turbolinksVisit(event) {
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", $("body").attr("class"));

    if (typeof gtag != "undefined") {
      gtag("event", "page_view", {
        page_path: window.location.href.replace(window.location.origin, "")
      });
    }

    pushPageViewDataLayer();

    if (window.location.search.length) {
      history.replaceState({
        turbolinks: {}
      }, "");
    }

    searchModal.hide();
    siteHeader.close();
    siteQuickCart.hide();
    siteHelperModal.hide();
  }

  function turbolinksRequestStart(event) {
    $("html").addClass("turbolinks-page-changing");
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", $("body").attr("class"));
  }

  function turbolinksRequestEnd(event) {}

  function turbolinksBeforeCache(event) {}

  function turbolinksBeforeRender(event) {
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", $("body").attr("class"));

    if (window.currentSection) {
      window.currentSection.dispose();
      window.currentSection = null;
    }
  }

  function turbolinksRender(event) {
    console.log("%cTurbolinks: " + event.type, "background: #00b12a; color: #FFFFFF;", $("body").attr("class"));

    if ($("#insta-feed").length) {
      instafeedApp();
    }
  }

  function changeLanguage(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if ($(event.delegateTarget).hasClass("it-lang-btn") && $("html").attr("lang") != "it") {
      window.location.href = $(event.delegateTarget).attr("href") + window.location.pathname;
    } else if ($(event.delegateTarget).hasClass("en-lang-btn") && $("html").attr("lang") != "en") {
      window.location.href = $(event.delegateTarget).attr("href") + window.location.pathname;
    } else if ($(event.delegateTarget).hasClass("es-lang-btn") && $("html").attr("lang") != "es") {
      window.location.href = $(event.delegateTarget).attr("href") + window.location.pathname;
    } else {
      return;
    }
  }

  function throttled_iOsResizeHandler() {
    var VH = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--ios-vh", "".concat(VH, "px"));
  }

  function resizeHandler(event) {
    throttled_iOsResizeHandler();
  }

  function pushPageViewDataLayer() {
    // console.log('dataLayer test', typeof dataLayer, location.pathname, document.title);
    console.log('PREVIOUS_PAGE', Globals.PREVIOUS_PAGE);

    if (typeof dataLayer != "undefined") {
      /* console.log('dataLayerPush', {
        event: "pageview",
        page: {
          path: location.pathname,
          title: document.title,
          previous_path: Globals.PREVIOUS_PAGE
        }
      }); */
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: "pageview",
        page: {
          path: location.pathname,
          title: document.title,
          previous_path: Globals.PREVIOUS_PAGE
        }
      });
    }
  }
})(window);
